import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "block text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider mb-1" }
const _hoisted_2 = { class: "text-sm text-slate-800 dark:text-slate-200" }

import { computed } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'DetailField',
  props: {
    label: {},
    value: {},
    capitalize: { type: Boolean }
  },
  setup(__props: any) {

const props = __props

const displayValue = computed(() => {
	if (!props.value && props.value !== 0) return '—'
	const val = String(props.value)
	return props.capitalize ? val.charAt(0).toUpperCase() + val.slice(1) : val
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("label", _hoisted_1, _toDisplayString(__props.label), 1),
    _createElementVNode("p", _hoisted_2, _toDisplayString(displayValue.value), 1)
  ]))
}
}

})